module.exports = __webpack_public_path__ + "static/media/mitarbeiter_false_active.79e4e238.jpg";